/* Common */
function bindMouseOverToMegaMenu (item) {
    item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {
          item.setAttribute("open", true);
        });
        item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  }
let items = document.querySelector(".header__inline-menu").querySelectorAll("details.mega-menu");
items.forEach(bindMouseOverToMegaMenu);


function sbinit() {
    document.querySelectorAll('.slider-scrollbar-show').forEach(function(container) {
        const ul = container.querySelector('ul');
        const scrollbar = container.querySelector('.slider-scrollbar');
        const scrollbarDrag = container.querySelector('.slider-scrollbar .drag');

        if (!ul || !scrollbar || !scrollbarDrag) return;

        const firstChild = ul.children[0];
        const marginLeft = window.getComputedStyle(firstChild).marginLeft;

        scrollbar.style.marginLeft = marginLeft;
        scrollbar.style.marginRight = marginLeft;

        const width = ul.clientWidth;
        const scrollWidth = ul.scrollWidth;
        const sbWidth = scrollbar.clientWidth;

        const dragWidth = (width / scrollWidth) * sbWidth;
        scrollbarDrag.style.width = dragWidth + 'px';

        ul.addEventListener('scroll', function() {
            const dragPosition = (ul.scrollLeft / scrollWidth) * sbWidth;
            scrollbarDrag.style.left = dragPosition + 'px';
        });
    });
}

sbinit();

window.addEventListener('resize', function() {
    sbinit();
});


document.querySelectorAll('.footer-block--menu h2').forEach(function(header) {
  header.addEventListener('click', function() {
    this.parentElement.classList.toggle('open');
  });
});


/*------------------------------------------------------------------------------------------------------*/

/* Home page */






/*------------------------------------------------------------------------------------------------------*/

/* Product page */


function Updateaslowas() {
  let aslas = 0;
  let title = $("#original_title").html();
  let title_array = title.split(" - ");
  let count = 0;
  if (
    title_array[1].indexOf("Count") != -1 ||
    title_array[1].indexOf("count") != -1
  ) {
    let count_text = title_array[1].replace(",", "");
    let count_array = count_text.split(" ");
    count = count_array[0];
    count = parseInt(count);
  }
  $(".shopacado-discount-table tbody tr").each(function () {
    let value = $(this).children("td").html();
    value = $.trim(value);
    let rowqty = parseInt(value.split(" ")[1]);
    const price = $(this).children("td").eq(1).find("span").html();
    let final_price = price.split(" ")[0];
    final_price = final_price.replace("$", "");
    final_price = parseFloat(final_price.replace(/[^0-9.]/g, ""));
    aslas = (final_price / count);
    aslas = parseFloat(aslas.toFixed(4)).toString()

    //hide price
    $(this).children("td").eq(1).find("span").hide();
    
    $(this).children("td").eq(1).prepend('<price>$'+aslas+'</price>');

    let new_qty = rowqty*count;
    $(this).children("td").eq(0).html("Buy "+new_qty);
    
  });

  if(aslas>0){
    $(".aslas").html("$" + aslas + " each");
    $(".aslowas").show();
  }

  updatePriceRow(1);
}

function UpdateProductCount(qty) {
  let title = $("#original_title").html();
  if (title) {
    let title_array = title.split(" - ");
    if (
      title_array[1].indexOf("Count") != -1 ||
      title_array[1].indexOf("count") != -1
    ) {
      let count_text = title_array[1].replace(",", "");
      let count_array = count_text.split(" ");
      let count = count_array[0];
      count = parseInt(count);
      let active_price = $("#active_price").val().replace("$", "");
      active_price = parseFloat(active_price.replace(/[^0-9.]/g, ""));
      if (count > 0) {
        const perunit = active_price / count;
        let total_count = count * qty;
        $(".qty-units-count").html(total_count);
        $(".qty-units-count-each").html("/ $" + parseFloat(perunit.toFixed(4)).toString() + " each");
        $(".qty-units").css("display", "inline-block");
      }
    }
  }
}

function updatePriceRow(qty) {
  let aslas = 0;
  let title = $("#original_title").html();
  let title_array = title.split(" - ");
  let count = 0;
  if (
    title_array[1].indexOf("Count") != -1 ||
    title_array[1].indexOf("count") != -1
  ) {
    let count_text = title_array[1].replace(",", "");
    let count_array = count_text.split(" ");
    count = count_array[0];
    count = parseInt(count);
  }
  
  $(".active_price_row").removeClass("active_price_row");
  $(".active_price").html($(".base_price").val());
  $("#active_price").val($(".base_price").val());
  $(".shopacado-discount-table tbody tr").each(function () {
    let value = $(this).children("td").html();
    value = $.trim(value);
    let rowqty = parseInt(value.split(" ")[1])/count;
    const price = $(this).children("td").eq(1).find("span").html();
    let final_price = price.split(" ")[0];
    if (qty >= rowqty) {
      $(".active_price_row").removeClass("active_price_row");
      $(this).addClass("active_price_row");
      $(".active_price").html(final_price);
      $("#active_price").val(final_price);
    }
  });
}

$("body").on("click", ".shopacado-discount-table tbody tr", function () {
  let aslas = 0;
  let title = $("#original_title").html();
  let title_array = title.split(" - ");
  let count = 0;
  if (
    title_array[1].indexOf("Count") != -1 ||
    title_array[1].indexOf("count") != -1
  ) {
    let count_text = title_array[1].replace(",", "");
    let count_array = count_text.split(" ");
    count = count_array[0];
    count = parseInt(count);
  }
  
  $(".active_price_row").removeClass("active_price_row");
  $(this).addClass("active_price_row");
  const price = $(this).children("td").eq(1).find("span").html();
  let final_price = price.split(" ")[0];
  $(".active_price").html(final_price);
  $("#active_price").val(final_price);
  let value = $(this).children("td").html();
  value = $.trim(value);
  let rowqty = parseInt(value.split(" ")[1]);
  rowqty= rowqty/count;
  $(".quantity__input").val(rowqty);
  updatePriceRow(rowqty);
  UpdateProductCount(rowqty);
});

$(window).on("load", function () {
  UpdateProductCount(1);
  setTimeout(Updateaslowas, 100);
});

$(".quantity__input").change(function (e) {
  updatePriceRow(parseInt(e.target.value));
  UpdateProductCount(e.target.value);
});



/*------------------------------------------------------------------------------------------------------*/

/* Collection list */







/*------------------------------------------------------------------------------------------------------*/


/* Collection */







/*------------------------------------------------------------------------------------------------------*/


/* Page */







/*------------------------------------------------------------------------------------------------------*/


/* Responsive */







/*------------------------------------------------------------------------------------------------------*/